import React from 'react'
import { useDropzone } from 'react-dropzone'
import PropTypes from 'prop-types'
import * as Icon from 'react-feather'

function FileDropZone(props) {
  const { acceptedFiles, getRootProps, getInputProps } = useDropzone(props)

  const files = acceptedFiles.map(file => (
    <p className={'text-primary text-center'} key={file.path}>
      {file.path} - <strong>{(file.size / 1048576).toFixed(2)} MB </strong>
    </p>
  ))

  return (
    <section
      className="u-p-medium u-text-muted c-form-group clickable"
      style={{ border: `${acceptedFiles.length > 0 ? '1px solid #8736a8' : '1px dashed #cccccc'}`, width: '100%' }}
    >
      <div {...getRootProps({ className: 'dropzone  text-center' })}>
        {acceptedFiles.length <= 0 ? (
          <div className="u-area">
            {props.icon ? props.icon : null}

            <input {...getInputProps()} />
            {props.label ? (
              <p className="u-text1">{props.label}</p>
            ) : (
              <p className="u-text1">Drag and drop some files here, or click to select files</p>
            )}
          </div>
        ) : (
          <div className={'u-area text-center'}>
            <Icon.CheckCircle size={40} color={'#333333'} />
            <aside className="u-text2">{files}</aside>
          </div>
        )}
      </div>
    </section>
  )
}

FileDropZone.propTypes = {
  icon: PropTypes.object,
  label: PropTypes.string,
}

export default FileDropZone
